<template>
    <section class="0-page-bottom-spacing-medium u-padding-bottom-large">

        <!-- <page-header>
            <slot slot="title">Webshop - {{ $t('global.products') }}</slot>
            <slot slot="description"><p v-html="WebshopIntro"></p></slot>
            <slot slot="action">
                <router-link v-if="isCustomer || isPersoneel || isMarketing" class="c-button c-button--base" :to="{ name: 'Contact' }">
                    {{ $t('global.make_appointment') }}
                </router-link>
            </slot>
        </page-header> -->

        <!-- FILTERS-->
        <v-overview-grid
            data-filter-table="ProductAggregations"
            data-table="Products"
            data-filter="ProductFilters"
            data-pagination="ProductPagination"
            grid-element="ProductBlock"
            :filters="filters">
        </v-overview-grid>

    </section>

</template>

<script>
    import PageHeader from '@/components/common/PageHeader'
    import VOverviewGrid from '@/components/OverviewGrid'

    export default {
        components: {
            PageHeader,
            VOverviewGrid,
        },
        data() {
            return{
                filters:[
                    {
                        value: 'Brands',
                        name: this.$t('product_overview.filters.brand'),
                        single: 'Brands'
                    },
                    {
                        value: 'Collection',
                        name: this.$t('product_overview.filters.collection'),
                        single: 'Collection',
                        width:120,
                        openOnLoad: true
                    },
                    {
                        value: 'Type',
                        name: this.$t('product_overview.filters.type'),
                        single: 'Type',
                        openOnLoad: true
                    },
                    {
                        value: 'StockOnly',
                        name: this.$t('product_overview.filters.stock'),
                        single: 'stockOnly',
                        allowMultiple: false,
                        width: 140,
                        openOnLoad: true
                    },
                    {
                        value: 'Colors',
                        name: this.$t('product_overview.filters.color'),
                        single: 'Colors'
                    },
                    {
                        value: 'Sizes',
                        name: this.$t('product_overview.filters.size'),
                        single: 'Sizes'
                    },                    
                    {
                        value: 'AgeSex',
                        name: this.$t('product_overview.filters.age_sex'),
                        single: 'AgeSex',
                        width:115
                    },                    
                    {
                        value: 'Label',
                        name: this.$t('product_overview.filters.label'),
                        single: 'Label'
                    },                    
                    {
                        value: 'PreOnly',
                        name: this.$t('product_overview.filters.pre'),
                        single: 'preOnly',
                        allowMultiple: false,
                        width:130
                    }
                ]
            }
        },
        computed: {
            WebshopIntro() {
                return this.$t('intro.customer_webshop');
            },
            isCustomer() {
                return this.$store.getters.isCustomer;
            },
            isPersoneel() {
                return this.$store.getters.isPersoneel;
            },
            isMarketing() {
                return this.$store.getters.isMarketing;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/customer/shop/Overview.vue